<template>
  <div>
    <h1>Reviews</h1>

    <v-overlay v-if="syncing" z-index="998">
      <v-progress-circular indeterminate size="64" />
    </v-overlay>
    <v-btn color="primary" @click="downloadExcel" class="buttonStyle">
      Download Reviews
    </v-btn>
    <v-data-table
      v-if="reviews"
      v-model="selected"
      :headers="headers"
      :items="reviews"
      :items-per-page="pageItems"
      item-key="id"
      show-select
      class="elevation-1 table datatable"
    >
      <template v-slot:[`header.id`]="{ header }">
        {{ header.text }}
        <v-menu offset-y :close-on-content-click="false">
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon v-bind="attrs" v-on="on">
              <v-icon small color="surface"> mdi-filter </v-icon>
            </v-btn>
          </template>
          <div style="background-color: white; width: 280px">
            <v-select
              label="Filter Downloads"
              :items="downloadFilter"
              outline
              dense
              color="secondary"
              class="select mr-3"
              v-model="selectedStatus"
              @input="onFilterStatus"
              ><template #item="{ item }">
                <span align-center> {{ item }}</span>
              </template>
            </v-select>
            <v-btn
              @click="cleanStatusFilter"
              small
              text
              color="primary"
              class="ml-2 mb-2"
              >Clean</v-btn
            >
          </div>
        </v-menu>
      </template>
      <template v-slot:[`item.id`]="{ item }">
        <v-row class="shopify_id">
          {{ item.shopify_order_id }}
        </v-row>
        <v-row class="date">
          {{ formatDate(item.date) }}
        </v-row>
        <v-row class="date">
          Downloaded:
          {{
            item.downloaded != null ? (item.downloaded ? "Yes" : "No") : "No"
          }}
        </v-row>
      </template>
      <template v-slot:[`item.reviewer`]="{ item }">
        <v-row>
          <v-col class="ma-0 pb-0">
            {{ item.customer_name }}
          </v-col>
        </v-row>
      </template>
      <template v-slot:[`item.product`]="{ item }">
        <v-row>
          <v-col class="ma-0 pb-0">
            {{ item.product_title }}
          </v-col>
        </v-row>
      </template>
      <template v-slot:[`item.review`]="{ item }">
        <v-row>
          <v-col class="ma-0 pb-0">
            <span
              ><v-icon color="yellow">mdi-star</v-icon>{{ item.rating }}</span
            ></v-col
          >
        </v-row>
        <v-row>
          <v-col>
            {{ item.description }}
          </v-col>
        </v-row>
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="initialize"> Reset </v-btn>
      </template>
    </v-data-table>

    <!--SNACKBAR FOR ERRORS-->
    <v-snackbar v-model="snackbar">
      {{ snackBarText }}

      <template>
        <v-btn color="secondary" text @click="snackbar = false"> Close </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>
      
      <script>
import axios from "axios";
import { BASE_URL } from "./baseUrl";
import * as XLSX from "xlsx/xlsx";
/* eslint-disable */
export default {
  name: "ReviewView",
  data() {
    return {
      headers: [
        {
          text: "Id",
          align: "start",
          sortable: false,
          value: "id",
        },
        { text: "Reviewer", value: "reviewer", filterable: false },
        { text: "Product", value: "product", filterable: false },
        { text: "Review", value: "review", filterable: false },
      ],
      totalReviews: 0,
      reviews: null,
      pageItems: 10,
      page: 1,
      loading: true,
      review: null,
      syncing: false,
      snackbar: false,
      reviewsCopy: null,
      snackBarText: "",
      selected: [],
      downloadFilter: ["Download: Yes", "Download: No"],
      options: {
        headers: {
          "Access-Control-Allow-Headers":
            "X-Custom-Header, Access-Control-Request-Headers",
          "x-access-token": localStorage.getItem("token"),
          //"Access-Control-Allow-Headers":"Access-Control-Allow-Origin"
        },
      },
      selectedStatus: "",
    };
  },
  mounted() {
    this.syncing = true;
    var url = BASE_URL + `reviews/`;
    axios
      .get(url, this.options)
      .then((response) => {
        console.log(response);
        this.reviews = response.data.reviews;
        this.reviewsCopy = response.data.reviews;
        this.totalReviews = response.data.totalCount;
        this.loading = false;
        this.syncing = false;
      })
      .catch((error) => {
        console.log(error);
        this.errored = true;
      })
      .finally(() => (this.loading = false));
  },
  methods: {
    getAllReviews() {
      this.syncing = true;
      let options = {
        headers: {
          "Access-Control-Allow-Headers":
            "X-Custom-Header, Access-Control-Request-Headers",
          "x-access-token": localStorage.getItem("token"),
          //"Access-Control-Allow-Headers":"Access-Control-Allow-Origin"
        },
      };
      var url = BASE_URL + `reviews/`;
      axios
        .get(url, options)
        .then((response) => {
          console.log(response);
          this.reviews = response.data.reviews;
          this.reviewsCopy = response.data.reviews;
          this.totalReviews = response.data.totalCount;
          this.loading = false;
          this.syncing = false;
        })
        .catch((error) => {
          console.log(error);
          this.errored = true;
        })
        .finally(() => (this.loading = false));
    },
    formatDate(date) {
      var newDate = new Date(date);
      return newDate.toLocaleDateString();
    },
    productString(products) {
      var desc = "";
      products.forEach((prod) => {
        desc += prod.quantity + " x " + prod.title + " ";
      });
      return desc;
    },
    downloadExcel() {
      var data = [
        [
          "product_id",
          "productTitle",
          "productUrl",
          "productImageUrl",
          "body",
          "rating",
          "media",
          "author",
          "email",
          "created_at",
        ],
      ];
      var ids = [];
      if (this.selected.length >= 1) {
        console.log("in selected");
        this.selected.forEach((review) => {
          var row = [];
          row.push(review.product_id);
          row.push(review.product_title);
          row.push(review.product_url);
          row.push(review.product_image);
          row.push(review.description);
          row.push(review.rating);
          row.push(review.media);
          row.push(review.customer_name);
          row.push(review.email);
          row.push(review.date);
          data.push(row);
          ids.push({
            product_id: review.product_id,
            review_id: review.review_id,
          });
        });
      } else {
        this.reviews.forEach((review) => {
          var row = [];
          row.push(review.product_id);
          row.push(review.product_title);
          row.push(review.product_url);
          row.push(review.product_image);
          row.push(review.description);
          row.push(review.rating);
          row.push(review.media);
          row.push(review.customer_name);
          row.push(review.email);
          row.push(review.date);
          data.push(row);
          ids.push({
            product_id: review.product_id,
            review_id: review.review_id,
          });
        });
      }
      console.log(data);
      var url = BASE_URL + `reviews/downloadStatus`;
      axios
        .put(url, ids, this.options)
        .then((response) => {
          if (response.data.hasError == false) {
            this.MakeDownloadTrue(ids);
          }
        })
        .catch((error) => {
          console.log(error);
          this.errored = true;
        });
      const worksheet = XLSX.utils.aoa_to_sheet(data);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
      XLSX.writeFile(workbook, "reviews.xlsx");
    },

    MakeDownloadTrue(ids) {
      for (var i = 0; i < this.reviews.length; i++) {
        var id = ids.find(
          (id) =>
            id.review_id == this.reviews[i].review_id &&
            id.product_id == this.reviews[i].product_id
        );
        if (id != null) {
          this.reviews[i].downloaded = true;
        }
      }
    },
    onFilterStatus() {
      console.log(this.selectedStatus);
      if (this.selectedStatus == "Download: Yes") {
        console.log(this.reviews)
        this.reviews = this.reviews.filter((el) => {
          return el.downloaded;
        });
      } else {
        this.reviews = this.reviews.filter((el) => {
          return !el.downloaded;
        });
      }
    },

    cleanStatusFilter() {
      (this.selectedStatus = ""), (this.reviews = this.reviewsCopy);
    },
  },
};
</script>
    
    <style scoped>
.shopify_id {
  font-size: 70%;
}
.date {
  font-size: 80%;
  font-weight: bold;
}

.syncButton {
  margin-top: 2%;
  float: right;
}

.search {
  margin: 2%;
}
.buttonStyle {
  margin-top: -2%;
  float: right;
}
.datatable {
  margin-top: 3%;
}

.orderInfo {
  font-size: 80%;
  margin: 2%;
  margin-bottom: 10%;
  padding: 2%;
  text-align: center !important;
  align-items: center !important;
  border-radius: 20%;
}
</style>